import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Div = styled.div.withConfig({
  displayName: "Excerpt__Div",
  componentId: "b4o306-0"
})(["margin:4px 0 32px 0;"]);
const Excerpt = ({
  children
}) => /*#__PURE__*/_jsx(Div, {
  children: children
});
export default Excerpt;